var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _rect0, _rect1, _line, _circle2, _rect10, _rect11, _rect12, _circle3, _path2, _circle4, _rect13, _rect14, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileCompatibilityNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.1621,
    y: 94.9414,
    width: 228,
    height: 158,
    rx: 14,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.1621,
    y: 260.941,
    width: 234,
    height: 26,
    rx: 13,
    fill: "#528FF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.1621,
    y: 252.941,
    width: 240,
    height: 27,
    rx: 13,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 246,
    r: 18,
    fill: "#192657"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 105,
    width: 10,
    height: 10,
    transform: "rotate(90 308 105)",
    fill: "#528FF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 125,
    width: 10,
    height: 10,
    transform: "rotate(90 308 125)",
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 145,
    width: 10,
    height: 10,
    transform: "rotate(90 308 145)",
    fill: "#528FF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 165,
    width: 10,
    height: 10,
    transform: "rotate(90 308 165)",
    fill: "#528FF5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 185,
    width: 10,
    height: 10,
    transform: "rotate(90 308 185)",
    fill: "#528FF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 205,
    width: 10,
    height: 10,
    transform: "rotate(90 308 205)",
    fill: "#528FF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 242V106.5C94.5 97.9998 92 141 119.5 189C141.5 227.4 176.333 240.333 191 242H65Z",
    fill: "#F58120"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 193.5,
    y: 30.5,
    width: 88,
    height: 152,
    rx: 12.5,
    fill: "#ECEFF3",
    stroke: "#192657",
    strokeWidth: 5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 29,
    width: 33,
    height: 3,
    fill: "#192657"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 191,
    y1: 159.5,
    x2: 284,
    y2: 159.5,
    stroke: "#192657",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 171.5,
    r: 7.5,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 94,
    width: 16,
    height: 16,
    fill: "#192657"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 94,
    width: 16,
    height: 16,
    fill: "#192657"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 94,
    width: 16,
    height: 16,
    fill: "#192657"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 84,
    r: 41,
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82.5L81.5 105.5C89 86.1667 111 49.2 123 48",
    stroke: "#192657",
    strokeWidth: 7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.5,
    cy: 248.5,
    r: 22.5,
    stroke: "#F58120",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 113,
    width: 5,
    height: 88,
    rx: 2.5,
    fill: "#192657"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 133,
    width: 5,
    height: 88,
    rx: 2.5,
    fill: "#192657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 30.0001C276.333 11.8335 340.6 16.2001 319 179C292 382.5 58.0001 351.5 38.0001 253.5C18.0001 155.5 -3.49988 22.5 76.5001 67.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileCompatibilityNew);
export default __webpack_public_path__ + "static/media/MobileCompatibilityNew.8f588eae1f829931f0ec1e64afed282e.svg";
export { ForwardRef as ReactComponent };